// Pure utility functions for transaction grouping

// Format amount with thousands separator
export const formatAmount = (amount) => {
    return new Intl.NumberFormat('he-IL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Math.abs(amount));
};

export const isPaymentAppTransaction = (transaction) => {
    const description = transaction.description?.toUpperCase() || '';
    return description.includes('BIT') || description.includes('PAYBOX') || description.includes('הפועלים-ביט');
};

export const getCategoryDescription = (categoryId, categoryLookup) => {
    if (!categoryLookup) return 'ללא קטגוריה';
    const category = categoryLookup.find(cat => cat.id === categoryId);
    return category ? category.description : 'ללא קטגוריה';
};

export const groupTransactionsByCategories = (regularTransactions, categoryLookup) => {
    const categoryGroups = {};

    for (const transaction of regularTransactions) {
        let groupKey;
        let categoryName;
        
        // If transaction has no categoryId, group as uncategorized
        if (!transaction.categoryId) {
            groupKey = 'uncategorized';
            categoryName = 'ללא קטגוריה';
        } else {
            // Check if the category exists in the lookup
            const category = categoryLookup?.find(cat => cat.id === transaction.categoryId);
            
            if (category) {
                // Valid category - use it as the group key
                groupKey = transaction.categoryId;
                categoryName = category.description;
            } else {
                // Category ID exists but not found in lookup (deleted category)
                // Group with other uncategorized transactions
                groupKey = 'uncategorized';
                categoryName = 'ללא קטגוריה';
            }
        }
        
        if (!categoryGroups[groupKey]) {
            categoryGroups[groupKey] = {
                categoryId: groupKey === 'uncategorized' ? null : transaction.categoryId,
                categoryName,
                transactions: [],
                totalAmount: 0
            };
        }
        
        categoryGroups[groupKey].transactions.push(transaction);
        // Add transaction amount to group total
        categoryGroups[groupKey].totalAmount += transaction.amount || 0;
    }
    
    // Convert to array and sort by category name
    return Object.values(categoryGroups).sort((a, b) =>
        a.categoryName.localeCompare(b.categoryName, 'he')
    );
};

export const groupTransactionsByCategory = (transactionsList, categoryLookup) => {
    const paymentAppTransactions = [];
    const regularTransactions = [];

    for (const transaction of transactionsList) {
        if (isPaymentAppTransaction(transaction)) {
            paymentAppTransactions.push(transaction);
        } else {
            regularTransactions.push(transaction);
        }
    }

    const categoryGroups = groupTransactionsByCategories(regularTransactions, categoryLookup);

    return { paymentAppTransactions, categoryGroups };
};